import { ouAdapter, MyOrganizationState, OuState } from "@organizations/models";
import { selectMyOrganizationsState, ousReducer } from "@organizations/store/reducers";
import { createSelector } from "@ngrx/store";

const { selectEntities, selectAll } = ouAdapter.getSelectors();

export const selectOusState = createSelector(
  selectMyOrganizationsState,
  (state: MyOrganizationState) => state.ous as OuState
);

export const selectOuEntities = createSelector(selectOusState, selectEntities);
export const selectAllOus = createSelector(selectOusState, selectAll);

export const selectOusLoading = createSelector(selectOusState, ousReducer.getOusLoading);
export const selectOuNameById = (entityId: string) =>
  createSelector(selectOuEntities, (entities) => entities[entityId]!.name);
